import React from 'react';
export const StopWatch = () => (
  <svg width="117px" height="86px" viewBox="0 0 117 86" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1540.000000, -1710.000000)">
        <g transform="translate(1541.000000, 1709.000000)">
          <g
            transform="translate(86.500000, 23.500000) scale(-1, 1) translate(-86.500000, -23.500000) translate(83.000000, 20.000000)"
            stroke="#AA81F7"
            strokeLinecap="round"
          >
            <path d="M3,6.057 L0,6" />
            <path d="M6,3 L6.057,0" />
            <path d="M4,4 L2,2" />
          </g>
          <path
            d="M27.5132,47.4633 L27.4132,48.7753"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M27.2148,51.3998 L27.1148,52.7118"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M29.938,50.2865 L28.626,50.1865"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M26.0024,49.9877 L24.6904,49.8887"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M106.745481,39.9397385 C106.708481,40.4197385 106.289481,40.7817385 105.808481,40.7447385 C105.326481,40.7087385 104.966481,40.2887385 105.002481,39.8067385 C105.038481,39.3267385 105.458481,38.9647385 105.939481,39.0027385 C106.421481,39.0387385 106.781481,39.4587385 106.745481,39.9397385"
            fill="#D71385"
          />
          <g
            transform="translate(42.813258, 21.520900) rotate(-6.000000) translate(-42.813258, -21.520900) translate(20.813258, 3.020900)"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g>
              <polyline
                stroke="#C3D3D8"
                points="11.7075 36.1625 3.3465 30.1125 0.0645 6.5595 41.3845 0.8415 43.1495 13.7155"
              />
              <path d="M34,8.436 L37.098,8" stroke="#DDE5E8" />
              <path d="M35,14.436 L38.098,14" stroke="#DDE5E8" />
              <path d="M7,12.586 L25.43,10" stroke="#DDE5E8" />
              <path d="M8,18.586 L26.43,16" stroke="#DDE5E8" />
            </g>
            <polyline
              stroke="#C3D3D8"
              points="3.3462 30.1127 10.7272 28.9797 11.7072 36.1627"
            />
          </g>
          <path
            d="M114.8662,82.0805 L83.1212,82.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.2041,82.0805 L18.4481,82.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.4482,82.0805 L0.4112,82.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.8496,82.1908 C79.8496,84.5008 72.1826,86.3728 62.7236,86.3728 C53.2646,86.3728 45.5976,84.5008 45.5976,82.1908 C45.5976,79.8798 53.2646,78.0078 62.7236,78.0078 C72.1826,78.0078 79.8496,79.8798 79.8496,82.1908"
            fill="#D0D7DA"
          />
        </g>
        <path
          d="M1637,1773 C1637,1774.10464 1636.10464,1775 1635,1775 C1633.89536,1775 1633,1774.10464 1633,1773 C1633,1771.89536 1633.89536,1771 1635,1771 C1636.10464,1771 1637,1771.89536 1637,1773 Z"
          stroke="#5EDAB0"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g transform="translate(1583.000000, 1729.000000)">
          <path
            d="M22.3686869,2.8922948 L22.3686869,0.132133021"
            stroke="#0B9CE5"
            strokeLinecap="square"
          />
          <path
            d="M18.2727273,0.208333333 L26.5909091,0.208333333"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            fill="#F3F4F6"
            cx="20.8636364"
            cy="24.1363636"
            r="20.8636364"
          />
          <path
            d="M36.3979123,9.45923132 C32.8163636,5.65089595 27.7313619,3.27272727 22.0909091,3.27272727 C11.2460449,3.27272727 2.45454545,12.0642267 2.45454545,22.9090909 C2.45454545,33.7539551 11.2460449,42.5454545 22.0909091,42.5454545 C32.9357733,42.5454545 41.7272727,33.7539551 41.7272727,22.9090909 C41.7272727,20.268332 41.2059913,17.7493249 40.2607153,15.4493564"
            stroke="#0B9CE5"
            fill="#FFFFFF"
            fillRule="nonzero"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            stroke="#DDE5E8"
            fill="#FFFFFF"
            cx="22.5"
            cy="22.5"
            r="15.1363636"
          />
          <polyline
            stroke="#FE5E48"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="22.9090909 14.7272727 22.9090909 23.4459925 26.6767456 27"
          />
        </g>
        <path
          d="M1595,1766.59043 C1597.94051,1768.88467 1601.63986,1770.25159 1605.65848,1770.25159 C1615.23594,1770.25159 1623,1762.48752 1623,1752.91006 C1623,1750.83471 1622.63544,1748.84451 1621.96686,1747"
          stroke="#F3F4F6"
          strokeLinecap="round"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);
